import React, { useEffect, useRef } from 'react'
import { Link } from 'react-router-dom'
import Accordion from 'react-bootstrap/Accordion';
export default function Navbar() {


   const open = useRef<HTMLHeadingElement>(null);
   const canopen = useRef<HTMLHeadingElement>(null);
   const mobilenav = useRef<HTMLHeadingElement>(null);

   const responsive = () => {
      open.current?.classList.toggle("info-open");
      canopen.current?.classList.toggle("overlay-open");
 
   }

const coursedetails = () =>{
 
      mobilenav.current?.classList.toggle("courseview")  
}


  const top = ()=>{
       window.scrollTo({ top: 0, });
      
   };

  

   return (
      <>





         <div className="fix">
            <div className="side-info" ref={open}>
               <div className="side-info-content">
                  <div className="offset-widget offset-logo mb-40">
                     <div className="row align-items-center">
                        <div className="col-9">
                           <Link to="/">
                              <img src="assets\img\slider\TECH-O-ZONE (8).jpg" alt="Logo" />
                           </Link>
                        </div>
                        <div className="col-3 text-end">
                           <button className="side-info-close" onClick={() => responsive()}><i className="fal fa-times"></i></button>
                        </div>
                     </div>
                  </div>


                  <div className="mobile-menu d-xl-none fix mean-container">
                     <div className="mean-bar">
                        <Link
                           to="#nav"
                           className="meanmenu-reveal"
                           style={{ right: 0, left: "auto", display: "inline" }}
                        >
                           <span>
                              <span>
                                 <span />
                              </span>
                           </span>
                        </Link>
                        <nav className="mean-nav">
                           <ul style={{ display: "none" }}>
                              <li className="menu-item-has-children">
                                 <Link onClick={()=>[top(),responsive()]} to="/">Home</Link>


                              </li>
                              <li className="menu-item-has-children" onClick={()=>coursedetails()} >
                                 <Link to={''} >Course</Link>
                                 <div ref={mobilenav} className='d-none'>
                                 <ul className="sub-menu"   >
                                             <li onClick={()=>[top(),responsive()]}><Link to="/Development" >Development</Link></li>
                                             <li  onClick={()=>[top(),responsive()]} ><Link to="/Markteing">Marketing</Link></li>
                                             <li onClick={()=>[top(),responsive()]} ><Link to="/Seo-course">SEO Course</Link></li>

                                          </ul>
                                          </div>
                                 <Link className="mean-expand" to="#" style={{ fontSize: 18 }}>
                                    {/* <i className="fal fa-plus" /> */}
                                    <i className="fas fa-window-minimize fa-lg"></i>
                                 </Link>
                              </li>
                              <li className="menu-item-has-children" onClick={()=>[top(),responsive()]} >
                                 <Link to="/Contact">contact us</Link>


                              </li>
                              <li className="menu-item-has-children" onClick={()=>[top(),responsive()]} >
                                 <Link to="/Contact">About</Link>


                              </li>

                           </ul>
                        </nav>
                     </div>
                  </div>

               </div>
            </div>
         </div>
         <div className="offcanvas-overlay " ref={canopen}></div>
         <div className="offcanvas-overlay-white" ></div>












         <header>
            <div className="header-area header-transparent sticky-header " style={{ backgroundColor: "white" }}>
               <div className="container-fluid">
                  <div className="header-main-wrapper">
                     <div className="row align-items-center">
                        <div className="col-xl-7 col-lg-7 col-md-5 col-sm-9 col-9">
                           <div className="header-left d-flex align-items-center">
                              <div className="header-logo">
                                 <Link to="/"><img src="assets\img\slider\TECH-O-ZONE (8).jpg" alt="logo" /></Link>
                              </div>


                              <div className="main-menu d-none d-xl-block">
                                 <nav id="mobile-menu">
                                    <ul>
                                       <li className="menu-item-has" onClick={()=>top()} ><Link to="/">Home</Link>

                                       </li>
                                       <li className="menu-item-has-children" onClick={()=>top()}><Link to="" >Course</Link>
                                          <ul className="sub-menu">
                                             <li onClick={()=>top()}><Link to="/Development">Development</Link></li>
                                             <li onClick={()=>top()}><Link to="/Markteing">Marketing</Link></li>
                                             <li onClick={()=>top()}><Link to="/Seo-course">SEO Course</Link></li>

                                          </ul>
            
                                       </li>
                                       <li onClick={()=>top()} className="menu-item-has"><Link to="/Contact">contact us</Link>

                                       </li>
                                       <li onClick={()=>top()} className="menu-item-has"><Link to="/Contact">About</Link>

                                       </li>

                                    </ul>
                                 </nav>
                              </div>
                           </div>
                        </div>
                        <div className="col-xl-5 col-lg-5 col-md-7 col-sm-3 col-3">
                           <div className="header-right d-flex align-items-center justify-content-end">
                              <div className="header-search d-none d-xxl-block mr-30">
                            
                              </div>


                              <div className="menu-bar d-xl-none ml-20">
                                 <Link className="side-toggle" to="javascript:void(0)">
                                    <div className="bar-icon" onClick={() => responsive()}>
                                       <span></span>
                                       <span></span>
                                       <span></span>
                                    </div>
                                 </Link>
                              </div>
                           </div>
                        </div>
                     </div>
                  </div>
               </div>
            </div>
         </header>

   


      </>
   )
}
